<template>
  <div class="border-error-container" :class="hasError">
    
    <!-- title -->
    <survey-caption v-bind:ind="ind">{{caption}}</survey-caption>

    <!-- options -->
    <div class="row survey-options-container center-flex-mobile">
      <div v-for="(option, index) in options" v-bind:key="index" class="span-2-lg span-3-md span-3-sm span-3-xs relative survey-option-outer ratio-survey-card" v-bind:class="getFirstOption(index)">
        <div class="survey-option-inner text-center" v-on:click="setOption(index)" v-bind:ref="index" v-bind:class="isCurrent(index)">
          <h1>{{index + 1}}</h1>
          <p class="hide-sm">{{option}}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import surveyCaption from '../molecules/surveyCaption'

  export default {
    props: ['ind', 'caption'],
    data () {
      return {
        error: false,
        current: null,
        options: ['Strongly Disagree', 'Somewhat Disagree', 'Neutral or No Opinion', 'Somewhat Agree', 'Strongly Agree'],
      }
    },
    methods: {
      getFirstOption(index) {
        if (index < 1) {
          return 'offset-3-lg offset-1-md'
        } else {
          return ''
        }
      },
      checkIncompleteResponse () {
        if(!this.$store.state.postSurvey[this.storeGroup] && this.incompleteFlag) { 
          this.error = true
        } else {
          this.error = false
        }
      },
      setOption (optionInd) {
        
        // set validations
        if (this.current === optionInd) {
          this.current = null
          this.$store.commit('setPostSurvey', {
            [this.storeGroup]: false
          })
        } else {
          this.current = optionInd
          this.$store.commit('setPostSurvey', {
            [this.storeGroup]: true
          })

          // set data 
          this.$store.commit('setPostSurveyData', {
            question: this.caption,
            response: optionInd + 1
          })

        }

        this.checkIncompleteResponse()

      },
      isCurrent (ind) {
        if(ind === this.current) {
          return 'hovered'
        } else {
          return ''
        }
      }
    },
    computed: {
      storeGroup () {
        return 'postsurvey-' + this.ind + '-group'
      },
      incompleteFlag () {
        return this.$store.state.postSurveyError
      },
      hasError () {
        if (this.error) {
          return 'border-error'
        }
        return ''
      },
    },
    watch: {
      incompleteFlag () {
        this.checkIncompleteResponse()
      },
    },
    mounted () {
      // initially set to false on mount.
      this.$store.commit('setPostSurvey', {
        [this.storeGroup]: false
      })
    },
    components: {
      'survey-caption': surveyCaption
    }
  }
</script>

<style scoped lang='scss'>

  @import '../../styles/variables';

  .survey-options-container {
    margin-bottom: 96px;
  }

  .survey-number {
    position: relative;
    text-align: right;
    top: 50%;
    transform: translateY(-50%);
    padding-right: 24px;
  }

  .survey-option-inner {
    position: relative;
    box-sizing: border-box;
    background: white;
    border: 1px solid #DCDDDF;
    width: 100%;
    height: 100%;
    transition: all $transition-1;
    cursor: pointer;
    p, h1 {
      transition: all $transition-1;
    }
    &:hover, &.hovered {
      border: 1px solid white;
      background: $blue;
      p, h1 {
        color: white;
      }
    }
    @media screen and (max-width: $sm-max) {
      display: flex;
      h1 {
        position: relative;
        margin: auto;
      }
    }
  }

  .survey-option-outer {
    padding-right: 24px;
    @media screen and (max-width: $md-max) , screen and (max-height: $md-height-max) {
      padding-right: 0px;
    }
  }

</style>


// WEBPACK FOOTER //
// surveyResponse.vue?e317d496